import React from 'react';
import type {Element} from 'react';
import type {VideoData} from '../store';

export default function DescriptionOverlay({video, clickClose}: {video: VideoData, clickClose: Function}): Element<any>  {
  let seasonInfo = '';

  if (video.season && video.episodeWithinSeason) {
    seasonInfo = <p>
      Season {video.season} Episode {video.episodeWithinSeason}
    </p>
  }

  return (
    <div className="show-overlay">
      <a className="no-delay show-overlay-close body-large" onClick={clickClose}>X</a>
      <div className="show-overlay-description">
        <p className="headline-section">
          { video.title }
        </p>
        {seasonInfo}
        <p dangerouslySetInnerHTML={ {__html: video.extendedDescription} }/>
      </div>
    </div>
  );
}